import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MessageService, MenuItem } from 'primeng/api';
import { GifcardVirtualService } from 'src/app/services/gifcardVirtual.service';
import { GiftCardVirtualsModel, GiftCardOrderSalesModel, GiftCardGroupModel } from "src/app/models/gifcardVirtual.model";
import { ExcelService } from "../../../services/excel.service";
import { ConfirmationService } from 'primeng/api';
import * as XLSX from 'xlsx';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { FileUploadControl, FileUploadValidators } from '@iplab/ngx-file-upload';
import { ImageService } from 'src/app/services/image.service';
import { ImageBarcode, ImageText } from 'src/app/models/image.model';
import { JobService } from 'src/app/services/job.service';
import { AuthService } from 'src/app/services/auth.service';
import { EmailService } from 'src/app/services/email.service';
import { EmailTemplateModel, EmailSendModel } from 'src/app/models/email.model';
import { FileService } from 'src/app/services/file.service';
import { TraceService } from 'src/app/services/trace.service';
var fnCloseDlg;

@Component({
  selector: 'ordersales-step4',
  templateUrl: './ordersales-step4.component.html',
  styleUrls: ['./ordersales-step4.component.css']
})
export class OrderSalesStep4Component implements OnInit {
  constructor(private _giftCardService: GifcardVirtualService,
    private messageService: MessageService,
    private excelService: ExcelService,
    private confirmationService: ConfirmationService,
    private imageService: ImageService,
    private jobService: JobService,
    private authService: AuthService,
    private emailService: EmailService,
    private fileService: FileService,
    private traceService: TraceService) { }

  id_order_sales: string;
  id_modelo_gift_card: string;
  id_cliente: string;
  id_contacto: string;
  id_assign_ncr: number;
  id_distr_ncr: number;
  id_template: number;
  id_job: number;
  id_emailsend: number;
  begin_sequence: number;
  fec_ini_vigencia;
  fec_fin_vigencia;
  fileModel: File;
  fileModelPath: string;
  email_contacto: string;
  itemGiftCardStep3;
  selectGiftCardStep3: GiftCardVirtualsModel;
  colsTablaGiftCardStep3: any[];
  totalCantidad: number = 0;
  totalSubtotal: number = 0;
  chkIncluirDatosAdicionales = false;
  uploadedFiles: any[] = [];
  displayDialog3 = false;
  blokedCheckAdicional = false;
  isStep3Complete = false;
  isVisibleList = false;
  urlFondoGiftCard: string;
  currentUser: string;
  img = new Image();
  zip = new JSZip();
  datasourceOrderSales: GiftCardOrderSalesModel[] = [];
  datasourceTablaGiftCardVirtualStep3: GiftCardVirtualsModel[] = [];
  datasourceGenerateImage: GiftCardVirtualsModel[] = [];
  datasourceGroup: GiftCardGroupModel[] = [];
  datasourceImageBarcode: ImageBarcode[] = [];
  datasourceImageText: ImageText[] = [];
  progressBarValue: number;
  index: number;
  count: number;
  length: number;
  msgDownload: string;
  isVisibleSlideBar: boolean = false;
  visibleButtonDownload: boolean = false;
  visibleButtonList: boolean = false;
  fileUploadControl = new FileUploadControl(FileUploadValidators.filesLimit(1));
  flgActivation: boolean = true;
  msgActivation: string;
  itemsOptionStep3: MenuItem[];

  downloadGiftCardZip: boolean = true;
  sendMasivo: boolean = true;
  datasourceEmailTemplate: EmailTemplateModel[];
  datasourceEmailSend: EmailSendModel[];
  email_endpoint: string;
  email_sender: string;
  email_recipient: string;
  email_subject: string;
  email_bodyhtml: string;
  email_path_file: string;
  email_name_client: string;
  visibleButtonProcessMail: boolean = false;
  visibleButtonSendMail: boolean = false;
  loading: boolean = false;
  itemOrderSales;
  fecini: Date;
  fecfin: Date;
  today = new Date();
  es;
  disabledButtonFecVigencia: boolean = false;

  ngOnInit() {
    this.createColumnsTablaGiftCardVirtual();
    this.localeESCalendar();
    this.buildOptionsStep3();
  }

  public loadParametersOrderSalesStep4(orderValues, funcionClose) {
    debugger;
    this.createColumnsTablaGiftCardVirtual();
    this.currentUser = this.authService.getCurrentUser();
    this.itemOrderSales = orderValues;
    this.id_order_sales = orderValues.ID_ORDER_SALES;
    this.id_modelo_gift_card = orderValues.ID_MODELO_GIFT_CARD;
    this.id_cliente = orderValues.ID_CLIENTE;
    this.id_contacto = orderValues.ID_CONTACT;
    this.begin_sequence = orderValues.BEGIN_SEQUENCE;
    this.id_assign_ncr = orderValues.ID_ASSIGN_NCR;
    this.id_distr_ncr = orderValues.ID_DISTR_NCR;
    this.id_template = orderValues.ID_TEMPLATE;
    this.fileModelPath = orderValues.IMG_MODELO_GIFT_CARD;
    this.email_contacto = orderValues.CORREO_CONTACTO;

    this.imageService.buildImageUrl(this.fileModelPath);
    this.populateTablaGiftCardVirtual();
    this.populateTableImageBarcode(this.id_template);
    this.populateTableImageText(this.id_template);
    this.buildOptionsStep3();
    fnCloseDlg = funcionClose;
  }

  createColumnsTablaGiftCardVirtual() {
    /**this.colsTablaGiftCardStep3 = [
      { field: 'BIN_GIFT_CARD', header: 'BIN Tarjeta', style: '40%' },
      { field: 'MONTO_GIFT_CARD', header: 'Monto', style: '10%' }
    ];*/

    //JRFC
    this.colsTablaGiftCardStep3 = [
      { field: 'BIN_GIFT_CARD', header: 'BIN Tarjeta', style: '20%' },
      { field: 'MONTO_GIFT_CARD', header: 'Monto', style: '10%' },
      { field: 'NOMBR_GIFT_CARD', header: 'Nombre', style: '10%' },
      { field: 'DOCUM_GIFT_CARD', header: 'Documento', style: '10%' },
      { field: 'TEXTO_GIFT_CARD', header: 'Texto', style: '30%' },
      { field: 'EMAIL_GIFT_CARD', header: 'Email', style: '20%' }
    ];
  }

  localeESCalendar() {
    this.es = {
      firstDayOfWeek: 0,
      dayNames: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
      dayNamesShort: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
      dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
      monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
      monthNamesShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
      today: 'Hoy',
      clear: 'Limpiar',
      dateFormat: 'yy/mm/dd',
      weekHeader: 'Wk'
    };
  }

  buildOptionsStep3() {
    this.itemsOptionStep3 = [
      {
        label: 'Masivo', icon: 'pi pi-users', command: () => {
          this.showSendMasivo();
        }
      },
      {
        label: 'Individual', icon: 'pi pi-user', command: () => {
          this.showSendIndividual();
        }
      }
    ];
  }

  onCloseDlgActivation() {
    fnCloseDlg();
  }

  populateTablaGiftCardVirtual() {
    this.loading = true;
    let order = {
      "p_id_order_gift_card": this.id_order_sales,
      "p_id_modelo_gift_card": this.id_modelo_gift_card,
      "p_id_cliente_gift_card": this.id_cliente,
      "p_id_contact_gift_card": this.id_contacto
    };
    this._giftCardService.GetGiftCardVirtualsNewCode(order).subscribe(
      (response: GiftCardVirtualsModel[]) => {
        this.datasourceTablaGiftCardVirtualStep3 = response;
        this.totalCantidad = this.datasourceTablaGiftCardVirtualStep3.length;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar gift card.' });
      }
    )
  }

  realoadListGiftCard() {
    let order = {
      "p_id_order_gift_card": this.id_order_sales,
      "p_id_modelo_gift_card": this.id_modelo_gift_card,
      "p_id_cliente_gift_card": this.id_cliente,
      "p_id_contact_gift_card": this.id_contacto
    };
    this._giftCardService.GetGiftCardVirtualsNewCode(order).subscribe(
      (response: GiftCardVirtualsModel[]) => {
        this.datasourceGenerateImage = response;
        this.isVisibleList = true;
        this.loading = false;
        this.visibleButtonDownload = true;
        this.visibleButtonProcessMail = true;
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Activación finalizada correctamente.' });
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar gift card.' });
      }
    )
  }

  populateDatasourceGroup() {
    let order = {
      "p_id_order_gift_card": this.id_order_sales,
      "p_id_modelo_gift_card": this.id_modelo_gift_card,
      "p_id_cliente_gift_card": this.id_cliente,
      "p_id_contact_gift_card": this.id_contacto
    };
    this._giftCardService.GetGiftCardGroup(order).subscribe(
      (response: GiftCardGroupModel[]) => {
        this.datasourceGroup = response;
        this.downloadGiftCardZip = true;
        this.generateGiftCardZip();
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar los grupos.' });
      }
    )
  }

  onChangeCheckDatos() {
    if (this.chkIncluirDatosAdicionales) {
      this.colsTablaGiftCardStep3 = [
        { field: 'BIN_GIFT_CARD', header: 'BIN Tarjeta', style: '20%' },
        { field: 'MONTO_GIFT_CARD', header: 'Monto', style: '10%' },
        { field: 'NOMBR_GIFT_CARD', header: 'Nombre', style: '10%' },
        { field: 'DOCUM_GIFT_CARD', header: 'Documento', style: '10%' },
        { field: 'TEXTO_GIFT_CARD', header: 'Texto', style: '30%' },
        { field: 'EMAIL_GIFT_CARD', header: 'Email', style: '20%' }
      ];
      this.isStep3Complete = true;
    }
    else {
      this.colsTablaGiftCardStep3 = [
        { field: 'BIN_GIFT_CARD', header: 'BIN Tarjeta', style: '40%' },
        { field: 'MONTO_GIFT_CARD', header: 'Monto', style: '10%' }
      ];
      this.isStep3Complete = false;
    }
  }

  cloneGiftCard(item: GiftCardVirtualsModel): GiftCardVirtualsModel {
    let giftcard = {};
    for (let prop in item) {
      giftcard[prop] = item[prop];
    }
    return item;
  }

  onRowSelectGiftCard(event) {
    this.itemGiftCardStep3 = this.cloneGiftCard(event.data);
  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.datasourceTablaGiftCardVirtualStep3, 'giftcard');
  }

  onUpload() {
    if (this.fileUploadControl.valid && this.fileUploadControl.value.length) {
      let workBook = null;
      let jsonData = null;
      const reader = new FileReader();
      const file = this.fileUploadControl.value[0];
      reader.onload = (event) => {
        const data = reader.result;
        workBook = XLSX.read(data, { type: 'binary' });
        jsonData = workBook.SheetNames.reduce((initial, name) => {
          const sheet = workBook.Sheets[name];
          initial[name] = XLSX.utils.sheet_to_json(sheet);
          return initial;
        }, {});
        this.updateDataAdicional(jsonData);
      }
      reader.readAsBinaryString(file);
      this.fileUploadControl.clear();
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe seleccionar solo 01 archivo excel de información adicional.' });
    }
  }

  updateDataAdicional(jsonData) {
    this.loading = true;

    for (let i = 0; i < jsonData.data.length; i++) {
      let email: string = jsonData.data[i].EMAIL_GIFT_CARD;
      if (this.validateEmail(email)) {
        let giftCard = {
          "p_id_gift_card": jsonData.data[i].ID_GIFT_CARD,
          "p_id_order_gift_card": this.id_order_sales,
          "p_id_modelo_gift_card": this.id_modelo_gift_card,
          "p_id_cliente_gift_card": this.id_cliente,
          "p_id_contact_gift_card": this.id_contacto,
          "p_nomb_gift_card": jsonData.data[i].NOMBR_GIFT_CARD,
          "p_docu_gift_card": jsonData.data[i].DOCUM_GIFT_CARD,
          "p_text_gift_card": jsonData.data[i].TEXTO_GIFT_CARD,
          "p_mail_gift_card": jsonData.data[i].EMAIL_GIFT_CARD
        };
        this._giftCardService.UpdateGiftCardDataPrint(giftCard).subscribe(
          (response) => {
            this.blokedCheckAdicional = true;
            this.isStep3Complete = false;

            if ((i + 1) == jsonData.data.length) {
              this.loading = false;
              //this.displayDialog3 = false;
              this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Se actualizó la información adicional correctamente.' });
            }
          },
          (error) => {
            this.loading = false;
            this.isStep3Complete = true;
            this.blokedCheckAdicional = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrió un error al actualizar la información adicional.' });
          }
        )
      }
      else {
        this.loading = false;
        this.isStep3Complete = true;
        this.blokedCheckAdicional = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Se ingreso un correo invalido en el registro número ' + (i + 1) + ' del excel.' });
        break;
      }
    }
  }

  updateOrderSalesActivation() {    
    if (!this.fecini || !this.fecfin) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Debe ingresar las fechas de inicio y fin de vigencia.' });
    } else {
      this.loading = true;
      let params = {
        "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
        "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
        "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
        "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT,
        "p_fec_ini_vigencia": this.fecini.getFullYear() + "/" + (this.fecini.getMonth() + 1) + "/" + this.fecini.getDate(),
        "p_fec_fin_vigencia": this.fecfin.getFullYear() + "/" + (this.fecfin.getMonth() + 1) + "/" + this.fecfin.getDate()
      }
      this._giftCardService.UpdateOrderSalesActivation(params).subscribe(
        (response) => {
          this.disabledButtonFecVigencia = true;
          this.loading = false;
          this.populateTablaGiftCardVirtual();
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Se actualizó las fechas de vigencia correctamente.' });
        },
        (error) => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar fechas de vigencia orden de compra.' });
        }
      )
    }
  }

  validateEmail(email: string) {
    let patron = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (email) {
      return patron.test(email);
    }
    return true;
  }

  onRefreshTable() {
    this.datasourceTablaGiftCardVirtualStep3 = [];
    this.populateTablaGiftCardVirtual();
  }

  onShowDialog() {
    this.displayDialog3 = true;
  }

  onShowConfirm() {
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    this.fecini.setHours(0, 0, 0, 0);
    this.msgActivation = '¿Está seguro de activar las Giftcard?';
    this.flgActivation = true;

    if (this.fecini > today) {
      this.msgActivation = 'La activación de las Giftcard se realizará después de la fecha actual. ¿Desea continuar?';
      this.flgActivation = false;
    }

    this.confirmationService.confirm({
      message: this.msgActivation,
      accept: () => {
        this.activateProcess();
      }
    });
  }

  createOrderSalesTrace(status: string, obs: string) {
    let params = {
      "p_id_order_gift_card": this.itemOrderSales.ID_ORDER_SALES,
      "p_id_modelo_gift_card": this.itemOrderSales.ID_MODELO_GIFT_CARD,
      "p_id_cliente_gift_card": this.itemOrderSales.ID_CLIENTE,
      "p_id_contact_gift_card": this.itemOrderSales.ID_CONTACT,
      "p_type_order_sales": 'V',
      "p_action": status,
      "p_observation": obs,
      "p_creationuser": this.currentUser
    };
    this.traceService.CreateGiftCardOrderSalesTrace(params).subscribe(
      (response) => {
        this.loading = false;
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Trace registrado correctamente.' });
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al crear el trace de la orden de compra' });
      }
    )
  }

  activateProcess() {
    this.loading = true;

    if (this.flgActivation) {
      this.updateGiftCardStatusNCR();
      this.createJobActivationNow();
      this.updateOrderSalesStatus(1); //status activo
      this.createOrderSalesTrace('ACTIVADO', 'Activación exitosa.');
    }
    else {
      this.updateSecuenceGiftCard();
      this.createJobActivation();
      this.updateOrderSalesStatus(2); //status pendiente
      this.createOrderSalesTrace('PENDIENTE', 'Activación pendiente.');
    }
  }

  updateOrderSalesStatus(flg_activo: number) {
    let params = {
      "p_id_order_gift_card": this.id_order_sales,
      "p_id_modelo_gift_card": this.id_modelo_gift_card,
      "p_id_cliente_gift_card": this.id_cliente,
      "p_id_contact_gift_card": this.id_contacto,
      "p_flg_activo": flg_activo
    }
    this._giftCardService.UpdateOrderSalesStatus(params).subscribe(
      (response) => {
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Actualización del estado de la orden de compra: exitoso.' });
      },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar el estado de la orden de compra.' });
      }
    )
  }

  updateGiftCardStatusNCR() {
    let params = {
      "p_branchId": 999,
      "p_assignationBatch": this.id_assign_ncr,
      "p_distributionBatch": this.id_distr_ncr,
      "p_status": "AC"
    };
    this._giftCardService.UpdateGiftCardStatusNCR(params).subscribe(
      (response) => {
        this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Activación paso 1: exitoso.' });
        this.updateSecuenceGiftCard();
        //this.createJobActivation();
        this.blokedCheckAdicional = true;
        this.chkIncluirDatosAdicionales = false;
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al activar las gift card en el NCR.' });
      }
    )
  }

  updateSecuenceGiftCard() {
    let tempSequence: number = this.begin_sequence;

    let paramsArray = []
    for (let i = 0; i < this.datasourceTablaGiftCardVirtualStep3.length; i++) {
      let params = {
        "p_id_gift_card": this.datasourceTablaGiftCardVirtualStep3[i].ID_GIFT_CARD,
        "p_id_order_gift_card": this.id_order_sales,
        "p_id_modelo_gift_card": this.id_modelo_gift_card,
        "p_id_cliente_gift_card": this.id_cliente,
        "p_id_contact_gift_card": this.id_contacto,
        "p_id_sequence": tempSequence
      };
      paramsArray.push(params);
      this.datasourceTablaGiftCardVirtualStep3[i].ID_SECUENCE_NCR = tempSequence;
      tempSequence++;
    }

    this._giftCardService.UpdateGiftCardSequenceNCRMassive(paramsArray).subscribe(
      (response) => {
        console.log("Resp UpdateGiftCardSequenceNCRMassive: " + response);
          this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Activación paso 2: exitoso.' });
          this.realoadListGiftCard();
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar la secuencia NCR.' });
      }
    )
  }

  createJobActivation() {
    let params = {
      "p_id_order_gift_card": this.id_order_sales,
      "p_id_modelo_gift_card": this.id_modelo_gift_card,
      "p_id_cliente_gift_card": this.id_cliente,
      "p_id_contact_gift_card": this.id_contacto,
      "p_id_assign_ncr": this.id_assign_ncr,
      "p_id_distr_ncr": this.id_distr_ncr,
      "p_creationuser": this.currentUser
    };
    this.jobService.CreateGiftCardJobActivation(params).subscribe(
      (response) => {
        let json = response;
        this.id_job = json.NEW_ID_JOB;
        if (this.flgActivation) {
          this.updateJobActivation();
        }
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al registrar Job.' });
      }
    )
  }

  createJobActivationNow() {
    let params = {
      "p_id_order_gift_card": this.id_order_sales,
      "p_id_modelo_gift_card": this.id_modelo_gift_card,
      "p_id_cliente_gift_card": this.id_cliente,
      "p_id_contact_gift_card": this.id_contacto,
      "p_id_assign_ncr": this.id_assign_ncr,
      "p_id_distr_ncr": this.id_distr_ncr,
      "p_creationuser": this.currentUser
    };
    this.jobService.CreateGiftCardJobActivation(params).subscribe(
      (response) => {
        let json = response;
        this.id_job = json.NEW_ID_JOB;
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al registrar Job.' });
      }
    )
  }

  updateJobActivation() {
    let params = {
      "p_id_job": this.id_job,
      "p_creationuser": this.currentUser,
      "p_type_operation": 1,
      "p_flg_activo": 1
    }
    this.jobService.UpdateGiftCardJobActivation(params).subscribe(
      (response) => {
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al actualizar Job.' });
      }
    )
  }

  populateTableImageBarcode(idTemplate) {
    let params = { "p_id_template": idTemplate };
    this.imageService.GetGiftCardBarcode(params).subscribe(
      (response: ImageBarcode[]) => {
        this.datasourceImageBarcode = response;
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar info image barcode.' });
      }
    )
  }

  populateTableImageText(idTemplate) {
    let params = { "p_id_template": idTemplate };
    this.imageService.GetGiftCardText(params).subscribe(
      (response: ImageText[]) => {
        this.datasourceImageText = response;
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al listar info image text.' });
      }
    )
  }

  buildConfigText(giftcard: GiftCardVirtualsModel) {
    this.datasourceImageText.forEach(text => {
      switch (text.KEY_TEXT) {
        case this.imageService.KEY_TEXTO:
          text.TEXT = giftcard.TEXTO_GIFT_CARD;
          break;
        case this.imageService.KEY_DNI:
          text.TEXT = giftcard.DOCUM_GIFT_CARD;
          break;
        case this.imageService.KEY_NOMBRE:
          text.TEXT = giftcard.NOMBR_GIFT_CARD;
          break;
        case this.imageService.KEY_SECUENCIAL:
          text.TEXT = giftcard.ID_SECUENCE_NCR.toString();
          break;
        case this.imageService.KEY_VIGENCIA:
          text.TEXT = giftcard.VALID_TEXT_GIFT_CARD;
          break;
        default:
          break;
      }
    });
  }

  uploadGiftCardFile(blob: Blob, typeFile: string, nameGiftCard: string, id_gift_card: string) {
    return new Promise(resolve => {
      let arrayOfBlob = new Array<Blob>();
      arrayOfBlob.push(blob);
      let fileGiftCard = new File(arrayOfBlob, nameGiftCard, { type: typeFile });

      let params = new FormData();
      params.append('p_id_order_gift_card', this.id_order_sales);
      params.append('p_id_gift_card', id_gift_card);
      params.append('p_type_send', this.sendMasivo == true ? "M" : "I");
      params.append('p_name_file', nameGiftCard);
      params.append('p_path_file', '');
      params.append('p_message_send', '');
      params.append('p_status_send', 'RE');
      params.append('p_creationuser', this.currentUser);
      params.append('file_giftcard', fileGiftCard);
      this.emailService.UploadFileGiftCard(params).subscribe(
        (response) => {
          resolve(true);
        },
        (error) => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al subir giftcard a repositorio.' });
        }
      );
    });
  }

  UploadFile(blob: Blob, typeFile: string, nameGiftCard: string) {
    return new Promise(resolve => {
      let arrayOfBlob = new Array<Blob>();
      arrayOfBlob.push(blob);
      let fileGiftCard = new File(arrayOfBlob, nameGiftCard, { type: typeFile });

      let params = new FormData();
      params.append('p_id_order_gift_card', this.id_order_sales);
      params.append('file', fileGiftCard);
      this.fileService.UploadFile(params).subscribe(
        (response) => {
          //resolve(true);
          let json = JSON.parse(JSON.stringify(response));
          let filepath = json.Location;
          saveAs(filepath, "file.zip");
          resolve(true);
        },
        (error) => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error en la carga de archivos.' });
        }
      );
    });
  }

  uploadGiftCard() {
    this.visibleButtonDownload = false;
    this.visibleButtonList = false;
    this.isVisibleSlideBar = true;
    this.loading = true;
    this.progressBarValue = 0;
    this.index = 0;
    this.count = 0;
    this.length = this.datasourceGenerateImage.length;
    let myImage = new Image();
    let barcode: ImageBarcode = this.datasourceImageBarcode[0];
    this.datasourceGenerateImage.forEach(giftcard => {
      let bin = giftcard.BIN_GIFT_CARD;
      barcode.BIN = bin;
      let monto = giftcard.MONTO_GIFT_CARD;
      let nameGiftCard = monto + '_2121' + bin.substring(bin.length - 7, bin.length - 1) + '.jpeg';

      this.imageService.createBarcode(barcode).then(load => {
        if (load) {

          this.buildConfigText(giftcard);
          this.imageService.textImage(this.datasourceImageText);
          let data = this.imageService.getContext().getImageData(0, 0,
            this.imageService.getCanvas().width, this.imageService.getCanvas().height);
          this.imageService.getContext().putImageData(data, 0, 0);
          myImage.src = this.imageService.getCanvas().toDataURL("images/jpeg");

          this.imageService.getCanvas().toBlob(blob => {
            this.index++;
            this.uploadGiftCardFile(blob, 'images/jpeg', nameGiftCard, giftcard.ID_GIFT_CARD.toString());

            if (this.index == this.length) {
              this.visibleButtonProcessMail = false;
              this.visibleButtonSendMail = true;
              this.loading = false;
              this.isVisibleSlideBar = false;
              this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Proceso de envio de correo exitoso.' });
            }
          });

        }
      });

    });
  }

  generateGiftCardZip() {
    console.log("Iniciando descarga de zip...")
    //this.visibleButtonDownload = false;
    this.visibleButtonList = false;
    this.isVisibleSlideBar = true;
    this.loading = true;
    let date = new Date();
    let nameZip = 'giftcard_' + date.getTime() + '.zip';
    this.progressBarValue = 0;
    this.index = 0;
    this.count = 0;
    this.length = this.datasourceGenerateImage.length;
    let myImage = new Image();
    let barcode: ImageBarcode = this.datasourceImageBarcode[0];
    this.datasourceGenerateImage.forEach(giftcard => {
      let bin = giftcard.BIN_GIFT_CARD;
      barcode.BIN = bin;
      let monto = giftcard.MONTO_GIFT_CARD;
      let nameGiftCard = monto + '_2121' + bin.substring(bin.length - 7, bin.length - 1) + '.jpeg';

      this.imageService.createBarcode(barcode).then(load => {
        if (load) {
          this.index++;
          this.buildConfigText(giftcard);
          this.imageService.textImage(this.datasourceImageText);
          let data = this.imageService.getContext().getImageData(0, 0,
            this.imageService.getCanvas().width, this.imageService.getCanvas().height);
          this.imageService.getContext().putImageData(data, 0, 0);
          myImage.src = this.imageService.getCanvas().toDataURL("images/jpeg");

          this.zip.file(nameGiftCard, this.imageService.urlToPromise(myImage.src), { binary: true });
          if (this.index == this.length) {
            this.zip.generateAsync({ type: "blob" }, (metadata) => {
              if (this.downloadGiftCardZip) {
                this.msgDownload = "Descargando...";
                this.progressBarValue = metadata.percent.toFixed(2);
                if (this.progressBarValue >= 100) {
                  this.msgDownload = "Descarga Finalizada";
                  this.loading = false;
                  setTimeout(() => {
                    this.isVisibleSlideBar = false;
                  }, 5000);
                }
              }
            }).then(content => {
              if (this.downloadGiftCardZip) {
                this.UploadFile(content, 'application/zip', nameZip)
                  .then(success => {
                    if (success) {
                      this.loading = false;
                      this.visibleButtonList = true;
                      this.visibleButtonProcessMail = false;
                      this.visibleButtonSendMail = false;
                      this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Proceso de descarga exitoso.' });
                    }
                  });
              }
              else {
                this.uploadGiftCardFile(content, 'application/zip', nameZip, giftcard.ID_GIFT_CARD.toString())
                  .then(success => {
                    if (success) {
                      this.visibleButtonProcessMail = false;
                      this.visibleButtonSendMail = true;
                      this.visibleButtonList = false;
                      this.loading = false;
                      this.isVisibleSlideBar = false;
                      this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Proceso de envio de correo exitoso.' });
                    }
                  });

              }
            });
          }
        }
      });
    });
  }

  processSendMail() {
    this.loading = true;
    let params = {
      "p_email_type": this.sendMasivo == true ? 2 : 1
    }
    this.emailService.GetGiftCardsEmailByType(params).subscribe(
      (response: EmailTemplateModel[]) => {
        this.datasourceEmailTemplate = response;
        this.email_sender = this.datasourceEmailTemplate[0].EMAILSENDER;
        this.email_subject = this.datasourceEmailTemplate[0].EMAILSUBJECT;
        this.email_bodyhtml = this.datasourceEmailTemplate[0].EMAILBODYHTML;
        this.email_endpoint = this.datasourceEmailTemplate[0].ENDPOINT;
        this.buildEmailSend().then(success => {
          if (success) {
            this.loading = false;
            this.isVisibleSlideBar = false;
            this.visibleButtonSendMail = false;
            this.visibleButtonList = true;
            this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'El proceso de envío de correo exitoso.' });
          }
        });
      },
      (error) => {
        this.loading = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al cargar template email.' });
      }
    );
  }

  buildEmailSend() {
    return new Promise(resolve => {
      let params = {
        "p_id_order_gift_card": this.id_order_sales
      }
      this.emailService.GetGiftCardsEmailSend(params).subscribe(
        (response: EmailSendModel[]) => {
          this.datasourceEmailSend = response;
          this.datasourceEmailSend.forEach(send => {
            this.id_emailsend = send.ID_EMAILSEND;
            this.email_recipient = send.EMAIL_SEND;
            //this.email_path_file = send.PATH_FILE;
            this.email_path_file = `${this.email_endpoint}/giftCardVirtual/downloadByHash?hash=${send.HASH}`
            this.email_name_client = send.NAME_SEND;
            this.sendEmail();
            resolve(true);
          });
        },
        (error) => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al compilar email.' });
        }
      );

    });
  }

  sendEmail() {
    //let formatName = this.email_bodyhtml.replace("${nombre_cliente}", this.email_name_client);
    //let bodyhtmlformat = formatName.replace("${path_file}", this.email_path_file);
    let params = {
      "p_id_emailsend": this.id_emailsend,
      "p_email_sender": this.email_sender,
      "p_email_subject": this.email_subject,
      //"p_email_bodyhtml" : bodyhtmlformat,
      "p_email_name_client": this.email_name_client,
      "p_email_type_send": this.sendMasivo == true ? "M" : "I",
      "p_email_recipient": this.sendMasivo == true ? this.email_contacto :
        (this.email_recipient ? this.email_recipient : ""),
      "p_email_path_file": this.email_path_file
    }
    this.emailService.SendEmailGiftCard(params).subscribe(
      (response) => {
      },
      (error) => {
        this.loading = false;
        this.isVisibleSlideBar = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Ocurrio un error al enviar correos.' });
      }
    );
  }

  showDownloadGiftCard() {
    this.confirmationService.confirm({
      message: '¿Está seguro de descargar las giftcard?',
      accept: () => {
        this.downloadGiftCardZip = true;
        this.generateGiftCardZip();
      }
    });
  }

  showSendMasivo() {
    this.confirmationService.confirm({
      message: '¿Está seguro de enviar las giftcard de forma masiva?',
      accept: () => {
        this.downloadGiftCardZip = false;
        this.sendMasivo = true;
        this.generateGiftCardZip();
      }
    });
  }

  showSendIndividual() {
    this.confirmationService.confirm({
      message: '¿Está seguro de enviar las giftcard de forma individual?',
      accept: () => {
        this.sendMasivo = false;
        this.uploadGiftCard();

      }
    });
  }

}